/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Language_HuInputs */

const en_nav_language_hu = /** @type {(inputs: Nav_Language_HuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magyar`)
};

const es_nav_language_hu = /** @type {(inputs: Nav_Language_HuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magyar`)
};

const de_nav_language_hu = /** @type {(inputs: Nav_Language_HuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magyar`)
};

const zh_nav_language_hu = /** @type {(inputs: Nav_Language_HuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magyar`)
};

const ar_nav_language_hu = /** @type {(inputs: Nav_Language_HuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magyar`)
};

const fr_nav_language_hu = /** @type {(inputs: Nav_Language_HuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magyar`)
};

const vi_nav_language_hu = /** @type {(inputs: Nav_Language_HuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magyar`)
};

const sw_nav_language_hu = /** @type {(inputs: Nav_Language_HuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magyar`)
};

const th_nav_language_hu = /** @type {(inputs: Nav_Language_HuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magyar`)
};

const bs_nav_language_hu = /** @type {(inputs: Nav_Language_HuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magyar`)
};

const ja_nav_language_hu = /** @type {(inputs: Nav_Language_HuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magyar`)
};

const ko_nav_language_hu = /** @type {(inputs: Nav_Language_HuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magyar`)
};

const pt_nav_language_hu = /** @type {(inputs: Nav_Language_HuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magyar`)
};

const it_nav_language_hu = /** @type {(inputs: Nav_Language_HuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magyar`)
};

const sv_nav_language_hu = /** @type {(inputs: Nav_Language_HuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magyar`)
};

const nl_nav_language_hu = /** @type {(inputs: Nav_Language_HuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magyar`)
};

const da_nav_language_hu = /** @type {(inputs: Nav_Language_HuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magyar`)
};

const nb_nav_language_hu = /** @type {(inputs: Nav_Language_HuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magyar`)
};

const fi_nav_language_hu = /** @type {(inputs: Nav_Language_HuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magyar`)
};

const pl_nav_language_hu = /** @type {(inputs: Nav_Language_HuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magyar`)
};

const ru_nav_language_hu = /** @type {(inputs: Nav_Language_HuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magyar`)
};

const tr_nav_language_hu = /** @type {(inputs: Nav_Language_HuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magyar`)
};

const hi_nav_language_hu = /** @type {(inputs: Nav_Language_HuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magyar`)
};

const id_nav_language_hu = /** @type {(inputs: Nav_Language_HuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magyar`)
};

const ms_nav_language_hu = /** @type {(inputs: Nav_Language_HuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magyar`)
};

const cs_nav_language_hu = /** @type {(inputs: Nav_Language_HuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magyar`)
};

const el_nav_language_hu = /** @type {(inputs: Nav_Language_HuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magyar`)
};

const he_nav_language_hu = /** @type {(inputs: Nav_Language_HuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magyar`)
};

const af_nav_language_hu = /** @type {(inputs: Nav_Language_HuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magyar`)
};

const hu_nav_language_hu = /** @type {(inputs: Nav_Language_HuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magyar`)
};

/**
* | output |
* | --- |
* | "Magyar" |
*
* @param {Nav_Language_HuInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const nav_language_hu = /** @type {((inputs?: Nav_Language_HuInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Language_HuInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_language_hu(inputs)
	if (locale === "de") return de_nav_language_hu(inputs)
	if (locale === "zh") return zh_nav_language_hu(inputs)
	if (locale === "ar") return ar_nav_language_hu(inputs)
	if (locale === "fr") return fr_nav_language_hu(inputs)
	if (locale === "vi") return vi_nav_language_hu(inputs)
	if (locale === "sw") return sw_nav_language_hu(inputs)
	if (locale === "th") return th_nav_language_hu(inputs)
	if (locale === "bs") return bs_nav_language_hu(inputs)
	if (locale === "ja") return ja_nav_language_hu(inputs)
	if (locale === "ko") return ko_nav_language_hu(inputs)
	if (locale === "pt") return pt_nav_language_hu(inputs)
	if (locale === "it") return it_nav_language_hu(inputs)
	if (locale === "sv") return sv_nav_language_hu(inputs)
	if (locale === "nl") return nl_nav_language_hu(inputs)
	if (locale === "da") return da_nav_language_hu(inputs)
	if (locale === "nb") return nb_nav_language_hu(inputs)
	if (locale === "fi") return fi_nav_language_hu(inputs)
	if (locale === "pl") return pl_nav_language_hu(inputs)
	if (locale === "ru") return ru_nav_language_hu(inputs)
	if (locale === "tr") return tr_nav_language_hu(inputs)
	if (locale === "hi") return hi_nav_language_hu(inputs)
	if (locale === "id") return id_nav_language_hu(inputs)
	if (locale === "ms") return ms_nav_language_hu(inputs)
	if (locale === "cs") return cs_nav_language_hu(inputs)
	if (locale === "el") return el_nav_language_hu(inputs)
	if (locale === "he") return he_nav_language_hu(inputs)
	if (locale === "af") return af_nav_language_hu(inputs)
	if (locale === "hu") return hu_nav_language_hu(inputs)
	return en_nav_language_hu(inputs)
});